import { ref } from 'vue'

// Shared reactive state for mobile drawer
const mobileDrawerOpen = ref(false)

export function useValuerSidebarDrawer() {
  return {
    mobileDrawerOpen,
    openDrawer: () => {
      mobileDrawerOpen.value = true
    },
    closeDrawer: () => {
      mobileDrawerOpen.value = false
    },
  }
}
